export enum BOOKING_STATUS {
  ABORTED = 'ABORTED',
  CANCELED = 'CANCELED',
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
}

export type BookingStatus =
  (typeof BOOKING_STATUS)[keyof typeof BOOKING_STATUS];
